import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, ElementRef,
  Input,
  QueryList,
  TemplateRef, ViewChild,
  ViewChildren
} from "@angular/core";


@Component({
  selector: 'int-scrolling-layer',
  templateUrl: './int-scrolling-layer.component.html',
  styleUrls: ['./int-scrolling-layer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntScrollingLayerComponent<T> implements AfterViewInit {

  @Input() selectedPredicate: (payload: T) => boolean = () => false

  @Input() itemContent!: TemplateRef<any>;
  @Input() list: Array<T> = [];

  @ViewChild('container') private readonly container!: ElementRef;
  @ViewChildren('item') private readonly cells!: QueryList<ElementRef>;

  constructor(
  ) {}

  getContainerHeight() {
    const {height} = this.container.nativeElement.getBoundingClientRect();
    return height;
  }


  ngAfterViewInit() {
    const cells = this.cells
      .map((item) => item.nativeElement);
    const selectedCell = this.list.find(this.selectedPredicate);
    if(selectedCell) {
      const id = this.list.indexOf(selectedCell);
      cells[id].scrollIntoView({ block: 'start', behavior: "smooth" });
    }
  }
}
